import http from "@/http-common";
import httpFile from "@/http-multipart";
import httpCommon from "@/http-common";
import {
    ALBUM_TYPE_CLASS,
    ALBUM_TYPE_SCHOOL,
} from "../constants/AlbumConstant";

class AlbumService {

    getAlbumDetailV2(idx) {
        return http.get(`/album-v2/${encodeURIComponent(idx)}`);
    }

    getAlbumsBySchoolV2(pageNumber, maxPageItem, filters = {}) {
        const params = {};
        if (pageNumber != null) params.pageNumber = pageNumber;
        if (maxPageItem != null) params.maxPageItem = maxPageItem;
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        const type = typeof filters.type === "string" &&
        [ALBUM_TYPE_SCHOOL, ALBUM_TYPE_CLASS].includes(filters.type)
            ? filters.type
            : null;
        if (type) params.type = type;
        if (filters.classId) params.classId = filters.classId;
        if (filters.approved !== "" && filters.approved != null) params.approved = filters.approved;
        return http.get(`/album-v2/school`, {params});
    }

    getAlbumPictureViewUrlV2(objectKey) {
        return http.get(`/minio/download-url`, {
            params: {objectKey, status: "VIEW"},
        });
    }

    downloadAlbumV2(albumIdx) {
        return http.get(`/album-v2/${encodeURIComponent(String(albumIdx))}/download`);
    }

    downloadPictureV2(albumIdx, pictureIdx) {
        return http.get(
            `/album-v2/${encodeURIComponent(String(albumIdx))}/pictures/${encodeURIComponent(String(pictureIdx))}/download`,
        );
    }

    deleteAlbumV2(albumIdx) {
        return http.delete(`/album-v2/${encodeURIComponent(String(albumIdx))}`);
    }

    updateAlbumApprovalV2(albumIdx, approved) {
        return http.put(
            `/album-v2/${encodeURIComponent(String(albumIdx))}/approval`,
            {approved: Boolean(approved)},
        );
    }

    updateAlbumApprovalBatchResultV2(albumIdxs, approved) {
        return http.put(`/album-v2/approval/batch-result`, {
            albumIdxs,
            approved: Boolean(approved),
        });
    }

    deleteAlbumBatchV2(albumIdxs) {
        return http.delete(`/album-v2/delete/batch`, {
            data: {albumIdxs},
        });
    }

    updatePictureApprovalV2(albumIdx, pictureIdx, approved) {
        return http.put(
            `/album-v2/${encodeURIComponent(String(albumIdx))}/pictures/${encodeURIComponent(String(pictureIdx))}/approval`,
            {approved: Boolean(approved)},
        );
    }

    setRepresentativePictureV2(albumIdx, pictureIdx) {
        return http.put(
            `/album-v2/${encodeURIComponent(String(albumIdx))}/pictures/${encodeURIComponent(String(pictureIdx))}/representative`,
        );
    }

    deletePicturesV2(albumIdx, pictureIdxs) {
        return http.delete(
            `/album-v2/${encodeURIComponent(String(albumIdx))}/pictures`,
            {data: {pictureIdxs}},
        );
    }

    deleteMultiAlbum(data) {
        return http.put(`/album/multi-album`, data);
    }

    createAlbumV2(data) {
        return http.post(`/album-v2/create-v2`, data);
    }

    /**
     * Updates Album V2 metadata, audience relations, and only the new picture
     * metadata. The Gateway allocates the MinIO object keys for those pictures.
     * Existing pictures are intentionally omitted from `data.pictures`.
     */
    updateAlbumV2(albumIdx, data) {
        return http.put(`/album-v2/${encodeURIComponent(String(albumIdx))}`, data);
    }

    getMinioUploadUrlV2(pictureId, fileName, thumbnail = false) {
        return http.post(`/album-v2/upload-url-v2`, {pictureId, fileName, thumbnail});
    }

    cleanupMinioObjectsV2(objectKeys) {
        return http.post(`/album-v2/uploaded-objects/cleanup-v2`, {objectKeys});
    }

    fallbackAlbumPicturesV2(idx, pictureIds, files) {
        const formData = new FormData();
        pictureIds.forEach((pictureId) => formData.append("pictureIds", pictureId));
        files.forEach((file) => formData.append("fileList", file));
        return httpFile.post(`/album-v2/${encodeURIComponent(idx)}/pictures/fallback-v2`, formData);
    }

    /**
     * Uses the update-safe fallback contract. Only the supplied new picture IDs
     * are switched to server storage; an existing album must never be deleted.
     * This is intentionally separate from the create fallback route.
     */
    fallbackAlbumPicturesV2Update(idx, pictureIds, files) {
        const formData = new FormData();
        pictureIds.forEach((pictureId) => formData.append("pictureIds", pictureId));
        files.forEach((file) => formData.append("fileList", file));
        return httpFile.post(
            `/album-v2/${encodeURIComponent(String(idx))}/pictures/fallback`,
            formData,
        );
    }

    getSyConfigPicture() {
        return http.get(`/album/search/sys_config_picture`)
    }

    /**
     * Hoành đánh dấu: Thêm Api lấy số lượng ảnh tối đa khi đăng Album
     */

    getAlbumMaxNumber() {
        return http.get(`/album/getAlbumMaxNumber`);
    }

    savePictureAlbum(formData) {
        return httpFile.post('/album/save/picture', formData)
    }

    getSizeListImage() {
        return httpCommon.get('/album/system/size-list-image')
    }

    startLegacyAlbumSync(data) {
        return http.post('/album-sync/migration/start', data);
    }

    startAllLegacyAlbumSync(data) {
        return http.post('/album-sync/migration/all/start', data);
    }

}

export default new AlbumService();
